module.exports = __webpack_public_path__ + "assets/mastercard.c69fc4e4.svg";